/* What's inside (BizDecks V2, 5 okt 2026). Eén script voor alle instanties op de pagina. */
(function () {
  if (window.__bdwScript) { return; } window.__bdwScript = true;

    // V2.9 (6 okt 2026): Model Dashboard op volle grootte. Eén venster voor de hele pagina, pas gemaakt bij de eerste tik.
    // Eerst het al geladen beeld (direct zichtbaar), daarna de 2000 px-versie. Tik op het beeld: ware grootte en terug.
    var zoomDlg = null, zoomToken = 0, hintTimer = 0;
    function zoomHint(on) {
      var h = zoomDlg && zoomDlg.querySelector('.bdw-zoom__hint'); if (!h) return;
      clearTimeout(hintTimer); h.classList.toggle('is-gone', !on);
      if (on) hintTimer = setTimeout(function () { h.classList.add('is-gone'); }, 4000);
    }
    function zoomDialog() {
      if (zoomDlg) return zoomDlg;
      var d = document.createElement('dialog'); d.className = 'bdw-zoom'; d.setAttribute('aria-label', 'Screenshot, full size'); d.tabIndex = -1;
      var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      d.innerHTML = '<div class="bdw-zoom__scroll"><img class="bdw-zoom__img" alt="" decoding="async"></div>' +
        '<button type="button" class="bdw-zoom__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<p class="bdw-zoom__hint is-gone">' + (touch ? 'Swipe to see more \u00b7 tap to zoom' : 'Click to zoom in') + '</p>';
      document.body.appendChild(d);
      var sc = d.querySelector('.bdw-zoom__scroll'), z = d.querySelector('.bdw-zoom__img');
      d.querySelector('.bdw-zoom__close').addEventListener('click', function () { d.close(); });
      sc.addEventListener('click', function (e) { if (e.target === sc) d.close(); });
      sc.addEventListener('scroll', function () { zoomHint(false); }, { passive: true });
      z.addEventListener('click', function (e) {
        var r = z.getBoundingClientRect(); var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        d.classList.toggle('is-full');
        var r2 = z.getBoundingClientRect();
        sc.scrollLeft += r2.left + fx * r2.width - e.clientX; sc.scrollTop += r2.top + fy * r2.height - e.clientY;
        zoomHint(false);
      });
      d.addEventListener('close', function () { document.documentElement.classList.remove('bdw-zoom-open'); zoomHint(false); });
      // Escape sluit altijd, ook als een ander script op de pagina de toets afvangt.
      window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { e.preventDefault(); d.close(); } }, true);
      zoomDlg = d; return d;
    }
    function openZoom(item) {
      var f = item.querySelector('[data-bdw-flip]'); var back = !!(f && f.classList.contains('is-flipped'));
      var img = item.querySelector(back ? '.bdw__face--back img' : '.bdw__face--front img') || item.querySelector('img');
      if (!img) return;
      var cur = img.currentSrc || img.getAttribute('src') || img.getAttribute(back ? 'data-bdw-src' : 'data-bdw-fsrc') || '';
      if (!cur) return;
      var big = cur.replace(/([?&])width=\d+/, '$1width=2000');
      var d = zoomDialog();
      if (typeof d.showModal !== 'function') { window.open(big, '_blank', 'noopener'); return; }
      var z = d.querySelector('.bdw-zoom__img'), sc = d.querySelector('.bdw-zoom__scroll');
      var t = ++zoomToken; d.classList.remove('is-full'); z.alt = img.alt || ''; z.src = cur;
      var pre = new Image(); pre.onload = function () { if (t === zoomToken && d.open) z.src = big; }; pre.src = big;
      d.showModal(); document.documentElement.classList.add('bdw-zoom-open');
      sc.scrollLeft = 0; sc.scrollTop = 0; zoomHint(true);
    }

  function bdwInit(root) {
    if (!root || root.__bdw) return;
    root.__bdw = true;
    var destroyed = false, listeners = [], observers = [], states = [];
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reduce = !!(motion && motion.matches);
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(root.querySelectorAll('[data-bdw-panel]'));
    var stacked = root.classList.contains('bdw--stacked');
    var near = false, watching = false;

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(function () { target.removeEventListener(type, handler, options); });
    }
    function mod(value, length) { return ((value % length) + length) % length; }
    function visible(panel) { return !panel.hidden && panel.getClientRects().length > 0; }
    function held(state) { return state.touching || Object.keys(state.pointers).length > 0; }
    function cancelSettlement(state) {
      clearTimeout(state.timer);
      cancelAnimationFrame(state.stableFrame);
      state.timer = state.stableFrame = 0;
    }
    function loadImages(panel, attr, srcsetAttr) {
      if (!panel) return;
      [].forEach.call(panel.querySelectorAll('img[' + attr + ']'), function (img) {
        var srcset = img.getAttribute(srcsetAttr);
        if (srcset) img.setAttribute('srcset', srcset);
        img.src = img.getAttribute(attr);
        img.removeAttribute(attr);
      });
    }
    function loadFronts(panel) { loadImages(panel, 'data-bdw-fsrc', 'data-bdw-fsrcset'); }
    function loadBacks(panel) { loadImages(panel, 'data-bdw-src', 'data-bdw-srcset'); }
    function activePanel() {
      for (var i = 0; i < panels.length; i++) if (!panels[i].hidden) return panels[i];
      return panels[0];
    }
    function watch() {
      if (watching || destroyed) return;
      watching = true;
      window.removeEventListener('scroll', watch);
      window.removeEventListener('load', watch);
      if (!('IntersectionObserver' in window)) {
        near = true;
        panels.forEach(function (panel) { if (stacked || !panel.hidden) loadFronts(panel); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (stacked) { loadFronts(entry.target); observer.unobserve(entry.target); }
          else { near = true; loadFronts(activePanel()); observer.disconnect(); }
        });
      }, { rootMargin: stacked ? '500px 0px' : '600px 0px' });
      observers.push(observer);
      if (stacked) panels.forEach(function (panel) { observer.observe(panel); });
      else observer.observe(root);
    }
    function nearest(state) {
      var positions = state.positions, x = state.tr.scrollLeft;
      if (!positions.length) return 0;
      var lo = 0, hi = positions.length - 1;
      while (lo < hi) {
        var middle = Math.floor((lo + hi) / 2);
        if (positions[middle] < x) lo = middle + 1;
        else hi = middle;
      }
      return lo > 0 && Math.abs(positions[lo - 1] - x) <= Math.abs(positions[lo] - x) ? lo - 1 : lo;
    }
    function update(panel) {
      var state = panel.__bdwTrack;
      if (!state || !state.ready || !visible(panel)) return;
      var index = nearest(state), tr = state.tr, n = state.originals.length;
      state.logical = n ? mod(index - (state.loop ? n : 0), n) : 0;
      var display = state.logical;
      if (!state.loop && n && tr.scrollWidth > tr.clientWidth + 2 && tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2) display = n - 1;
      var count = panel.querySelector('.bdw__count');
      var text = (n ? display + 1 : 0) + ' / ' + n;
      if (count && count.textContent !== text) count.textContent = text;
      var arrows = panel.querySelectorAll('.bdw__arrow');
      for (var i = 0; i < arrows.length; i++) {
        var disabled = n < 2 || (!state.loop && (arrows[i].getAttribute('data-dir') === '-1' ? tr.scrollLeft <= 2 : tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2));
        if (arrows[i].disabled !== disabled) arrows[i].disabled = disabled;
      }
    }
    function placeArrows(panel) {
      var flip = panel.querySelector('.bdw__flip'), wrap = panel.querySelector('.bdw__trackwrap');
      if (!flip || !wrap) return;
      var a = flip.getBoundingClientRect(), b = wrap.getBoundingClientRect();
      if (a.height) wrap.style.setProperty('--bdw-ay', Math.round(a.top - b.top + a.height / 2) + 'px');
      if (panel.getAttribute('data-bdw-topic') !== 'cards' || !window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      var arrows = panel.querySelectorAll('.bdw__arrow--side'), state = panel.__bdwTrack;
      if (arrows.length !== 2 || !state || !state.originals.length) return;
      var tr = state.tr, aw = arrows[0].offsetWidth || 40, vw = document.documentElement.clientWidth;
      var left = tr.getBoundingClientRect().left + (parseFloat(getComputedStyle(tr).paddingLeft) || 0);
      var width = state.originals[0].getBoundingClientRect().width;
      wrap.style.setProperty('--bdw-axl', Math.round(Math.max(2, (left - aw) / 2) - b.left) + 'px');
      wrap.style.setProperty('--bdw-axr', Math.round(Math.max(2, (vw - left - width - aw) / 2) - (vw - b.right)) + 'px');
    }
    function focusOriginal(state) {
      var active = document.activeElement;
      var clone = active && active.closest ? active.closest('[data-bdw-clone]') : null;
      if (!clone || clone.parentNode !== state.tr) return;
      var original = state.originals[Number(clone.getAttribute('data-bdw-index'))];
      if (!original) return;
      var node = active, path = [];
      while (node && node !== clone) {
        path.unshift([].indexOf.call(node.parentNode.children, node));
        node = node.parentNode;
      }
      var target = original;
      path.forEach(function (index) { target = target && target.children[index]; });
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }
    function instantJump(state, x) {
      if (destroyed || state.rebasing || held(state) || !visible(state.panel)) return false;
      cancelSettlement(state);
      var tr = state.tr, oldSnap = tr.style.scrollSnapType, oldBehavior = tr.style.scrollBehavior;
      state.rebasing = true;
      tr.classList.add('is-rebasing');
      tr.style.scrollSnapType = 'none';
      tr.style.scrollBehavior = 'auto';
      void tr.offsetWidth;
      focusOriginal(state);
      tr.scrollTo({ left: x, top: tr.scrollTop, behavior: 'auto' });
      update(state.panel);
      state.jumpFrame = requestAnimationFrame(function () {
        state.jumpFrame = requestAnimationFrame(function () {
          tr.style.scrollSnapType = oldSnap;
          tr.style.scrollBehavior = oldBehavior;
          tr.classList.remove('is-rebasing');
          state.rebasing = false;
          if (destroyed) return;
          update(state.panel);
          if (state.pendingRefresh) { state.pendingRefresh = false; refresh(state, true); }
          if (!state.rebasing && state.queuedTarget !== null && !held(state)) {
            var target = state.queuedTarget;
            state.queuedTarget = null;
            if (state.loop && (target < 0 || target >= state.positions.length)) {
              var direction = target - nearest(state), n = state.originals.length;
              target = n + mod(target, n);
              if (direction > 0 && target <= nearest(state)) target += n;
              else if (direction < 0 && target >= nearest(state)) target -= n;
            }
            animateTo(state, target, state.queuedSmooth);
          } else if (!state.rebasing) scheduleSettlement(state, 160);
        });
      });
      return true;
    }
    function normalize(state) {
      if (!state.loop || !state.span || state.rebasing || held(state) || !visible(state.panel)) return;
      var x = state.tr.scrollLeft;
      if (x < state.start - 0.5 || x >= state.start + state.span - 0.5) {
        instantJump(state, state.start + mod(x - state.start, state.span));
      } else focusOriginal(state);
    }
    function finishSettlement(state) {
      if (destroyed || held(state) || state.rebasing || !visible(state.panel)) return;
      state.commandIndex = null;
      update(state.panel);
      if (state.pendingRefresh) { state.pendingRefresh = false; refresh(state, true); }
      else normalize(state);
    }
    function scheduleSettlement(state, delay) {
      cancelSettlement(state);
      if (destroyed || !state.ready || state.rebasing || held(state) || !visible(state.panel)) return;
      state.timer = setTimeout(function () {
        state.timer = 0;
        var previous = state.tr.scrollLeft, stableSince = performance.now();
        function sample(now) {
          state.stableFrame = 0;
          if (destroyed || held(state) || state.rebasing || !visible(state.panel)) return;
          var x = state.tr.scrollLeft;
          if (Math.abs(x - previous) > 0.1) { previous = x; stableSince = now; }
          if (now - stableSince >= 80 && now - state.lastScroll >= 80) finishSettlement(state);
          else state.stableFrame = requestAnimationFrame(sample);
        }
        state.stableFrame = requestAnimationFrame(sample);
      }, delay);
    }
    function makeLoop(state) {
      if (!root.hasAttribute('data-bdw-loop') || state.originals.length < 2) return;
      var tr = state.tr;
      function clone(original) {
        var copy = original.cloneNode(true);
        copy.setAttribute('data-bdw-clone', 'true');
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = false;
        [copy].concat([].slice.call(copy.querySelectorAll('*'))).forEach(function (el) {
          ['id', 'data-shopify-editor-block', 'data-shopify-editor-section', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'for', 'headers', 'list'].forEach(function (attr) { el.removeAttribute(attr); });
        });
        [].forEach.call(copy.querySelectorAll('button,a,input,select,textarea,[tabindex],[contenteditable]'), function (el) {
          el.setAttribute('tabindex', '-1');
          if (el.hasAttribute('contenteditable')) el.setAttribute('contenteditable', 'false');
        });
        state.groups[Number(copy.getAttribute('data-bdw-index'))].push(copy);
        return copy;
      }
      if (!state.loop) {
        var before = document.createDocumentFragment();
        state.originals.forEach(function (original) { before.appendChild(clone(original)); });
        tr.insertBefore(before, tr.firstChild);
        state.loop = tr.__loop = true;
        state.afterCycles = 0;
        state.panel.__n = state.originals.length;
      }
      var gap = parseFloat(getComputedStyle(tr).columnGap) || 0;
      var stride = state.originals[0].getBoundingClientRect().width + gap;
      var cycles = stride > 0 ? Math.max(1, Math.ceil((tr.clientWidth + gap) / (stride * state.originals.length))) : 1;
      while (state.afterCycles < cycles) {
        var after = document.createDocumentFragment();
        state.originals.forEach(function (original) { after.appendChild(clone(original)); });
        tr.appendChild(after);
        state.afterCycles++;
      }
    }
    function refresh(state, preserve) {
      if (destroyed || !visible(state.panel)) return;
      if (held(state) || state.rebasing) { state.pendingRefresh = true; return; }
      var logical = preserve && state.ready ? state.logical : 0;
      makeLoop(state);
      var tr = state.tr, list = [].slice.call(tr.children), r = tr.getBoundingClientRect();
      var style = getComputedStyle(tr), padding = parseFloat(style.scrollPaddingLeft);
      if (!isFinite(padding)) padding = parseFloat(style.paddingLeft) || 0;
      var x = tr.scrollLeft;
      state.positions = list.map(function (el) { return el.getBoundingClientRect().left - r.left - tr.clientLeft + x - padding; });
      var n = state.originals.length;
      state.start = state.loop ? state.positions[n] : 0;
      state.span = state.loop ? state.positions[2 * n] - state.positions[n] : 0;
      state.width = tr.clientWidth;
      state.itemWidth = n ? state.originals[0].getBoundingClientRect().width : 0;
      state.ready = true;
      state.commandIndex = null;
      placeArrows(state.panel);
      var index = state.loop ? n + mod(logical, n) : Math.min(logical, Math.max(0, n - 1));
      var target = state.positions[index];
      if (target !== undefined && Math.abs(tr.scrollLeft - target) > 0.25) instantJump(state, Math.max(0, Math.min(tr.scrollWidth - tr.clientWidth, target)));
      else update(state.panel);
    }
    function requestRefresh(state) {
      if (destroyed || state.refreshFrame) return;
      state.refreshFrame = requestAnimationFrame(function () { state.refreshFrame = 0; refresh(state, true); });
    }
    function animateTo(state, index, smooth) {
      if (!state.positions.length) return;
      state.commandIndex = index;
      var x = Math.max(0, Math.min(state.tr.scrollWidth - state.tr.clientWidth, state.positions[index]));
      state.tr.scrollTo({ left: x, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      scheduleSettlement(state, 160);
    }
    function move(panel, delta, smooth) {
      var state = panel && panel.__bdwTrack;
      if (!state || !state.originals.length || held(state)) return;
      if (!state.ready) refresh(state, false);
      if (state.rebasing) {
        var pending = state.queuedTarget === null ? (state.loop ? state.originals.length + state.logical : state.logical) : state.queuedTarget;
        state.queuedTarget = state.loop ? pending + delta : Math.max(0, Math.min(state.positions.length - 1, pending + delta));
        state.queuedSmooth = smooth;
        return;
      }
      var from = state.commandIndex === null ? nearest(state) : state.commandIndex;
      var target = from + delta;
      if (state.loop && (target < 0 || target >= state.positions.length)) {
        var cycles = Math.floor(nearest(state) / state.originals.length) - 1;
        state.queuedTarget = target - cycles * state.originals.length;
        state.queuedSmooth = smooth;
        instantJump(state, state.start + mod(state.tr.scrollLeft - state.start, state.span));
      } else animateTo(state, Math.max(0, Math.min(state.positions.length - 1, target)), smooth);
    }
    function releasePointer(event) {
      states.forEach(function (state) {
        var id = String(event.pointerId === undefined ? 0 : event.pointerId);
        if (!state.pointers[id]) return;
        delete state.pointers[id];
        scheduleSettlement(state, 160);
      });
    }
    function releaseTouch(event) {
      states.forEach(function (state) {
        if (!state.touching) return;
        state.touching = !!(event.touches && event.touches.length);
        scheduleSettlement(state, 160);
      });
    }
    panels.forEach(function (panel) {
      var tr = panel.querySelector('[data-bdw-track]');
      if (!tr) return;
      var originals = [].slice.call(tr.children);
      var state = { panel: panel, tr: tr, originals: originals, groups: [], flips: [], positions: [], pointers: {}, touching: false, loop: false, ready: false, rebasing: false, logical: 0, timer: 0, stableFrame: 0, jumpFrame: 0, refreshFrame: 0, updateFrame: 0, lastScroll: 0, commandIndex: null, queuedTarget: null, queuedSmooth: true, pendingRefresh: false };
      originals.forEach(function (item, index) { item.setAttribute('data-bdw-index', String(index)); state.groups[index] = [item]; });
      panel.__bdwTrack = state;
      tr.__bdwRefresh = function () { refresh(state, true); };
      states.push(state);
      listen(tr, 'scroll', function () {
        state.lastScroll = performance.now();
        if (!state.updateFrame) state.updateFrame = requestAnimationFrame(function () { state.updateFrame = 0; update(panel); });
        scheduleSettlement(state, 160);
      }, { passive: true });
      if ('onscrollend' in tr) listen(tr, 'scrollend', function () { scheduleSettlement(state, 0); }, { passive: true });
      listen(tr, 'pointerdown', function (event) {
        cancelSettlement(state);
        state.pointers[String(event.pointerId === undefined ? 0 : event.pointerId)] = true;
        state.commandIndex = state.queuedTarget = null;
      }, { passive: true });
      listen(tr, 'touchstart', function () { cancelSettlement(state); state.touching = true; state.commandIndex = state.queuedTarget = null; }, { passive: true });
      listen(tr, 'wheel', function () { state.commandIndex = state.queuedTarget = null; }, { passive: true });
      listen(tr, 'mousedown', function (event) {
        if (event.target.closest('[data-bdw-clone] button,[data-bdw-clone] a')) event.preventDefault();
      });
      listen(tr, 'focusin', function () { focusOriginal(state); });
      listen(tr, 'keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        move(panel, event.key === 'ArrowRight' ? 1 : -1, false);
      });
      refresh(state, false);
    });
    listen(window, 'pointerup', releasePointer, { passive: true });
    listen(window, 'pointercancel', releasePointer, { passive: true });
    listen(window, 'touchend', releaseTouch, { passive: true });
    listen(window, 'touchcancel', releaseTouch, { passive: true });
    listen(window, 'blur', function () {
      states.forEach(function (state) { state.pointers = {}; state.touching = false; scheduleSettlement(state, 160); });
    });
    listen(window, 'resize', function () { states.forEach(requestRefresh); }, { passive: true });
    if ('ResizeObserver' in window) {
      var resize = new ResizeObserver(function () {
        states.forEach(function (state) {
          if (!visible(state.panel)) return;
          var width = state.originals.length ? state.originals[0].getBoundingClientRect().width : 0;
          if (!state.ready || state.width !== state.tr.clientWidth || Math.abs(state.itemWidth - width) > 0.1) requestRefresh(state);
          else placeArrows(state.panel);
        });
      });
      states.forEach(function (state) { resize.observe(state.tr); if (state.originals.length) resize.observe(state.originals[0]); });
      observers.push(resize);
    }
    if (motion) {
      var motionChange = function () { reduce = motion.matches; };
      if (motion.addEventListener) listen(motion, 'change', motionChange);
      else if (motion.addListener) { motion.addListener(motionChange); listeners.push(function () { motion.removeListener(motionChange); }); }
    }
    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = index === i;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus && tabs[index]) tabs[index].focus();
      if (panels[index]) {
        near = true;
        var state = panels[index].__bdwTrack;
        if (state) refresh(state, true);
        loadFronts(panels[index]);
      }
    }
    tabs.forEach(function (tab, index) {
      listen(tab, 'click', function () { select(index); });
      listen(tab, 'keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        select(mod(index + (event.key === 'ArrowRight' ? 1 : -1), tabs.length), true);
      });
    });
    function flip(item) {
      if (!item) return;
      var panel = item.closest('[data-bdw-panel]'), state = panel && panel.__bdwTrack;
      if (!state) return;
      var index = Number(item.getAttribute('data-bdw-index')), group = state.groups[index];
      if (!group || !group.length) return;
      loadBacks(panel);
      var entry = state.flips[index];
      if (!entry) {
        var initial = item.querySelector('[data-bdw-flip]');
        if (!initial) return;
        var on = initial.classList.contains('is-flipped');
        entry = state.flips[index] = { desired: on, applied: on, busy: false, timer: 0 };
      }
      entry.desired = !entry.desired;
      function render() {
        if (destroyed || entry.busy || entry.desired === entry.applied) return;
        entry.applied = entry.desired;
        group.forEach(function (card) {
          var face = card.querySelector('[data-bdw-flip]'), button = card.querySelector('.bdw__turn');
          if (face) face.classList.toggle('is-flipped', entry.applied);
          if (button) {
            button.setAttribute('aria-pressed', entry.applied ? 'true' : 'false');
            var text = button.querySelector('span');
            if (text) text.textContent = button.getAttribute(entry.applied ? 'data-back' : 'data-front');
          }
        });
        if (reduce) return;
        entry.busy = true;
        var inner = item.querySelector('.bdw__inner');
        var complete = function (event) {
          if (event && (event.target !== inner || event.propertyName !== 'transform')) return;
          clearTimeout(entry.timer);
          entry.timer = 0;
          if (inner) {
            inner.removeEventListener('transitionend', complete);
            inner.removeEventListener('transitioncancel', complete);
          }
          entry.stop = null;
          entry.busy = false;
          render();
        };
        entry.stop = function () {
          if (inner) {
            inner.removeEventListener('transitionend', complete);
            inner.removeEventListener('transitioncancel', complete);
          }
        };
        if (inner) {
          inner.addEventListener('transitionend', complete);
          inner.addEventListener('transitioncancel', complete);
        }
        entry.timer = setTimeout(function () { complete(); }, 1000);
      }
      render();
    }
    var dialog = root.querySelector('.bdw__dialog'), slot = root.querySelector('[data-bdw-slot]');
    function closeVideo() { if (slot) slot.innerHTML = ''; if (dialog && dialog.open) dialog.close(); }
    function openVideo(url) {
      if (!dialog || !slot) { window.open(url, '_blank', 'noopener'); return; }
      slot.innerHTML = '';
      var video = document.createElement('video');
      video.controls = true; video.playsInline = true; video.preload = 'metadata'; video.src = url;
      slot.appendChild(video);
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
    if (dialog) {
      listen(dialog, 'close', function () { if (slot) slot.innerHTML = ''; });
      listen(dialog, 'click', function (event) { if (event.target === dialog) closeVideo(); });
      var close = root.querySelector('.bdw__close');
      if (close) listen(close, 'click', closeVideo);
    }
    listen(root, 'click', function (event) {
      var play = event.target.closest('[data-bdw-video]');
      if (play) { event.stopPropagation(); openVideo(play.getAttribute('data-bdw-video')); return; }
      var arrow = event.target.closest('.bdw__arrow');
      if (arrow) { move(arrow.closest('[data-bdw-panel]'), Number(arrow.getAttribute('data-dir')), true); return; }
      var zoom = event.target.closest('[data-bdw-zoom]') || (event.target.closest('[data-bdw-flip]') && event.target.closest('[data-bdw-topic="dashboard"] .bdw__item--screen'));
      if (zoom) { var item = zoom.closest('.bdw__item'); if (item) { loadFronts(item.closest('[data-bdw-panel]')); openZoom(item); } return; }
      var hit = event.target.closest('.bdw__turn,[data-bdw-flip]');
      if (hit) flip(hit.closest('.bdw__item'));
    });
    listen(root, 'pointerdown', function (event) { var panel = event.target.closest('[data-bdw-panel]'); loadFronts(panel); loadBacks(panel); }, { passive: true });
    if (document.readyState === 'complete') watch();
    else { listen(window, 'load', watch); listen(window, 'scroll', watch, { passive: true }); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!destroyed) states.forEach(requestRefresh); });
    root.__bdwDestroy = function () {
      destroyed = true;
      listeners.forEach(function (remove) { remove(); });
      observers.forEach(function (observer) { observer.disconnect(); });
      states.forEach(function (state) {
        cancelSettlement(state);
        cancelAnimationFrame(state.jumpFrame);
        cancelAnimationFrame(state.refreshFrame);
        cancelAnimationFrame(state.updateFrame);
        state.flips.forEach(function (entry) { if (entry) { clearTimeout(entry.timer); if (entry.stop) entry.stop(); } });
      });
    };
  }
  function bdwAll() { [].forEach.call(document.querySelectorAll('[data-bdw-root]'), bdwInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bdwAll);
  else bdwAll();
  document.addEventListener('shopify:section:load', bdwAll);
  document.addEventListener('shopify:section:unload', function (event) {
    [].forEach.call(event.target.querySelectorAll('[data-bdw-root]'), function (root) { if (root.__bdwDestroy) root.__bdwDestroy(); });
  });
})();
